import { SvgIcon } from '@material-ui/core'
import DirectionsBoatIcon from '@material-ui/icons/DirectionsBoat'
import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import SupervisorIcon from '@material-ui/icons/SupervisorAccount'
import PolicyIcon from '@material-ui/icons/Policy'
import WhatsAppIcon from '@material-ui/icons/WhatsApp'
import React from 'react'

export const ITEMS_MOVIMIENTO = [
  // CUPOS---------------------------------------------------------------------------------------------------
  {
    icono: <EventAvailableIcon />,
    name: 'Cupos',
    url: '/cupos',

    subgrupos:
      [
        {
          name: 'Asignados',
          url: '/cupos/asignacion'
        },
        {
          name: 'Nominados',
          url: '/cupos/nominados'
        },
        {
          name: 'Adelanto',
          url: '/cupos/adelanto'
        },
        {
          name: 'Cumplimiento',
          url: '/cupos/cumplimiento'
        },
        {
          name: 'Codigo de cupos',
          url: '/listado/codigoCupo'
        }
      ]
  },
  // CAMIONES---------------------------------------------------------------------------------------------------
  { icono: <LocalShippingIcon />,
    name: 'Camiones',
    url: '/camiones',
    subgrupos: [{
      name: 'Ingreso',
      url: '/ingreso',
      subgrupos: [
        {
          name: 'Ingreso minimo',
          url: '/ingreso/minimo'
        },
        {
          name: 'Ingreso completo',
          url: '/ingreso/completo'
        },
        {
          name: 'Control de turno salida',
          url: '/ingreso/controlturno'
        },
        {
          name: 'Reimpresión de comprobante',
          url: '/ingreso/reimpresioncomprobante'
        },
        {
          name: 'Búsqueda de carta de porte',
          url: '/ingreso/busquedacpa'
        },
        {
          name: 'Abandono',
          url: '/ingreso/abandono'
        },
        {
          name: 'Desabandono',
          url: '/ingreso/desabandono'
        },
        {
          name: 'Rechazo en Playa',
          url: '/ingreso/rechazoenplaya'
        },
        {
          name: 'Anulacion ingreso',
          url: '/ingreso/anulacioningreso'
        },
        {
          name: 'Egreso de playa',
          url: '/ingreso/egresoplaya'
        },
        {
          name: 'Cuadro de mando',
          url: '/ingreso/cuadrodemando'
        },
        {
          name: 'Consulta camiones en playa',
          url: '/consultacpaenplaya'
        },
        {
          name: 'Consulta camiones abandonados',
          url: '/consultacpaabandonada'
        },
        {
          name: 'Solicitud de camiones en playa',
          url: '/ingreso/pedidoegresoplaya'
        },
        {
          name: 'Consulta estado CTG',
          url: '/consultaCupo'
        }
      ]
    },
    {
      name: 'Calado',
      url: '/calado',
      subgrupos: [
        {
          name: 'Proceso',
          url: '/calado/proceso'
        },
        {
          name: 'Cargas pendientes',
          url: '/calado/cargaspendientes'
        },
        {
          name: 'Cargas pendientes entregadores',
          url: '/calado/cargaspendientesentregadores'
        },

        {
          name: 'Egreso',
          url: '/calado/egresocalado'
        },
        {
          name: 'Egreso QR',
          url: '/calado/egresoqrcalado'
        },
        {
          name: 'Anulación de egreso',
          url: '/calado/anulacionegreso'
        },
        {
          name: 'Muestras',
          url: '/calado/muestras'
        },
        {
          name: 'Consultar muestras enviadas',
          url: '/calado/consultaMuestras'
        },
        {
          name: 'Calles de calado',
          url: '/calado/callesdecalado'
        },
        {
          name: 'Preingreso calado 1-2',
          url: '/preingresoCalado/1-2'
        },
        {
          name: 'Preingreso calado 3-4',
          url: '/preingresoCalado/3-4'
        }
        // {
        //   name: 'Pedido de camiones para bruto',
        //   url: '/calado/pedidosegresocalado'
        // }
      ]
    },
    {
      name: 'Pesado bruto',
      url: '/pesado',
      subgrupos: [
        {
          name: 'Bruto',
          url: '/pesado/pesobruto'
        },
        {
          name: 'Actividad de barrera',
          url: '/pesado/actividadbarrera'
        }
      ]
    },
    {
      name: 'Pesado destare',
      url: '/pesado',
      subgrupos: [
        {
          name: 'Destare',
          url: '/pesado/pesodestare'
        },
        {
          name: 'Reimpresión de comprobante de descarga',
          url: '/pesado/reimpresioncomprobantedescarga'
        }
      ]
    },
    {
      name: 'Listados y Consultas',
      url: '/listado',
      subgrupos: [
        {
          name: 'Cartas de Porte Vetadas',
          url: '/listado/cartasDePorteVetadas'
        },
        // {
        //   name: 'Camiones sin cupo',
        //   url: '/listado/camionessincupo'
        // },
        {
          name: 'Cupo no vigente',
          url: '/listado/cpasincupo'
        },
        {
          name: 'Camiones en Playa',
          url: '/listado/consultaCpaPlaya'
        },
        // {
        //   name: 'Camiones en Playa listos para Egreso',
        //   url: '/listado/consultaCpaPlayaEgreso'
        // },
        {
          name: 'Camiones entre Playa y Calado',
          url: '/listado/consultaCpaEntrePlayaCalado'
        },
        {
          name: 'Camiones Calados',
          url: '/listado/consultaCaladoAceptado'
        },
        {
          name: 'Camiones Rechazados en Calado',
          url: '/listado/consultaCaladoRechazado'
        },
        {
          name: 'Camiones Rechazados Administrativamente',
          url: '/listado/consultaCeaRechazadaAdministrativamente'
        },
        {
          name: 'Camiones Penalizados',
          url: '/listado/consultaCamionesPenalizados'
        },
        {
          name: 'Camiones listos para Bruto',
          url: '/listado/consultaCeaListaParaBrutoListado'
        },
        {
          name: 'Camiones rechazados en Bruto',
          url: '/listado/consultaCeaRechazadosBruto'
        },
        {
          name: 'Camiones entre Bruto y Destare',
          url: '/listado/consultaCeaConPesoListado'
        },
        {
          name: 'Camiones Volcados',
          url: '/listado/consultaCeaConVolcado'
        },
        {
          name: 'Listado para Representantes/Entregadores',
          url: '/listado/listadoRepresentantes'
        },
        {
          name: 'Camiones Descargados',
          url: '/listado/consultaCeaConPesoNeto'
        },
        {
          name: 'Descarga Procesada en Stock',
          url: '/listado/consultaDescargaProcesadaStock'
        },
        {
          name: 'CTGs sin Confirmación Definitiva',
          url: '/listado/consultaCpaSinDefinitiva'
        }
      ]
    },
    // {
    //   name: 'Modificar CPA',
    //   url: '/camiones/modificarcpa'
    // },
    {
      name: 'Notificaciones Chofer',
      url: '/notificacioneschofer'
    }
    ]
  },
  // GERENCIAL---------------------------------------------------------------------------------------------------
  {
    icono: <SvgIcon>
      <g><rect fill='none' height='24' width='24' /></g><g><g><path d='M13,8.57c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43s1.43-0.64,1.43-1.43S13.79,8.57,13,8.57z' /><path d='M13,3C9.25,3,6.2,5.94,6.02,9.64L4.1,12.2C3.85,12.53,4.09,13,4.5,13H6v3c0,1.1,0.9,2,2,2h1v3h7v-4.68 c2.36-1.12,4-3.53,4-6.32C20,6.13,16.87,3,13,3z M16,10c0,0.13-0.01,0.26-0.02,0.39l0.83,0.66c0.08,0.06,0.1,0.16,0.05,0.25 l-0.8,1.39c-0.05,0.09-0.16,0.12-0.24,0.09l-0.99-0.4c-0.21,0.16-0.43,0.29-0.67,0.39L14,13.83c-0.01,0.1-0.1,0.17-0.2,0.17h-1.6 c-0.1,0-0.18-0.07-0.2-0.17l-0.15-1.06c-0.25-0.1-0.47-0.23-0.68-0.39l-0.99,0.4c-0.09,0.03-0.2,0-0.25-0.09l-0.8-1.39 c-0.05-0.08-0.03-0.19,0.05-0.25l0.84-0.66C10.01,10.26,10,10.13,10,10c0-0.13,0.02-0.27,0.04-0.39L9.19,8.95 c-0.08-0.06-0.1-0.16-0.05-0.26l0.8-1.38c0.05-0.09,0.15-0.12,0.24-0.09l1,0.4c0.2-0.15,0.43-0.29,0.67-0.39l0.15-1.06 C12.02,6.07,12.1,6,12.2,6h1.6c0.1,0,0.18,0.07,0.2,0.17l0.15,1.06c0.24,0.1,0.46,0.23,0.67,0.39l1-0.4c0.09-0.03,0.2,0,0.24,0.09 l0.8,1.38c0.05,0.09,0.03,0.2-0.05,0.26l-0.85,0.66C15.99,9.73,16,9.86,16,10z' /></g></g>
    </SvgIcon>,
    name: 'Gerencial',
    url: '/cuadroDeMando',
    subgrupos: [
      {
        name: 'Reportes PBI',
        url: '/cuadroDeMando',
        subgrupos: [
          {
            name: 'Descargas y Embarque Online',
            url: '/cuadroDeMando/ReportePbiDesYEmbOnline'
          },
          {
            name: 'Embarques',
            url: '/cuadroDeMando/ReportePbiEmbarque'
          },
          {
            name: 'Descargas',
            url: '/cuadroDeMando/ReportePbiDescarga'
          },
          {
            name: 'Mermas y Calidad',
            url: '/cuadroDeMando/ReportePbiMermasYCalidad'
          },
          {
            name: 'Existencias Online',
            url: '/cuadroDeMando/ReporteExistenciasOnline'
          },
          {
            name: 'Stock Exportadores',
            url: '/cuadroDeMando/ReporteStockExportadores'
          }
        ]
      }

      // {
      //   name: 'Cuadro de Mando Exportador/Cereal',
      //   url: '/cuadroDeMando/cdmdec'
      // },
      // {
      //   name: 'Cuadro de Mando Calado',
      //   url: '/cuadroDeMando/cdmc'
      // }
    ]
  },
  // TRENES---------------------------------------------------------------------------------------------------
  // {
  //   icono: <TrainIcon />,
  //   name: 'Trenes',
  //   url: '/trenes',
  //   subgrupos:
  //     [
  //       {
  //         name: 'Alta Carta de Porte',
  //         url: '/trenes/ingreso/alta'
  //       },
  //       {
  //         name: 'Modificacion de Carta de Porte',
  //         url: '/trenes/ingreso/modificacion'
  //       },
  //       {
  //         name: 'Administración de Vagones (ABM)',
  //         url: '/trenes/ingreso/vagones'
  //       }
  //     ]
  // },

  // SUPERVISOR ----------------------------------------------------------------------------------------------
  { icono: <SupervisorIcon />,
    name: 'Supervisor',
    url: '/supervisor',
    subgrupos: [
      {
        name: 'Productividad',
        url: '/productividad',
        subgrupos: [
          {
            name: 'Histogramas',
            url: '/productividad/histogramas'
          },

          {
            name: 'Estadísticas de volcadoras',
            url: '/productividad/estadisticasvolcadoras'
          }
        ]
      },
      {
        name: 'Penalización de camiones',
        url: '/supervisor/penalizaciontransporte'
      },
      {
        name: 'Cuadro de mando descarga',
        url: '/cuadroDeMando/cdmd'
      },
      {
        name: 'Proyección stock',
        url: '/supervisor/proyeccion',
        subgrupos: [
          {
            name: 'Proyección stock',
            url: '/supervisor/proyeccionstock'
          },
          {
            name: 'Simular proyección',
            url: '/supervisor/simularproyeccion'
          }
        ]
      },
      {
        name: 'Configuración',
        url: '/supervisor/configuracion',
        subgrupos: [
          {
            name: 'Configuración del sistema',
            url: '/supervisor/configuraciondelsistema'
          },
          {
            name: 'Cereales',
            url: '/supervisor/configuracioncereales'
          }
        ]
      }
    ]
  },
  // EMBARQUE-------------------------------------------------------------------------------------------------
  { icono: <DirectionsBoatIcon />,
    name: 'Embarque',
    url: '/embarque',
    subgrupos:
        [
          {
            name: 'Buques anunciados',
            url: '/embarque/anunciosbuques'
          },
          {
            name: 'Comunicación de Embarque',
            url: '/embarque/comunicacionEmbarque'
          },
          {
            name: 'Listado de buques',
            url: '/embarque/buques'
          },
          {
            name: 'Supervisión de embarque',
            url: '/embarque/supervisionembarque'
          }

          //         {
          //           name: 'Plan de Embarque',
          //           url: '/embarque/plan'
          //         },
          //         {
          //           name: 'Control de Embarque',
          //           url: '/embarque/control'
          //         },
          //         {
          //           name: 'Muestra de Embarque',
          //           url: '/embarque/muestra'
          //         },
          //         {
          //           name: 'Parte de Embarque',
          //           url: '/embarque/parte'
          //         },
          //         {
          //           name: 'Plan de Embarque',
          //           url: '/embarque/demoras'
          //         }
        ]
  },
  // STOCK-------------------------------------------------------------------------------------------------

  {
    icono: <SvgIcon>
      <g><rect fill='none' height='24' width='24' /></g><g><path d='M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M13.03,7.06L14.09,6l1.41,1.41 L16.91,6l1.06,1.06l-1.41,1.41l1.41,1.41l-1.06,1.06L15.5,9.54l-1.41,1.41l-1.06-1.06l1.41-1.41L13.03,7.06z M6.25,7.72h5v1.5h-5 V7.72z M11.5,16h-2v2H8v-2H6v-1.5h2v-2h1.5v2h2V16z M18,17.25h-5v-1.5h5V17.25z M18,14.75h-5v-1.5h5V14.75z' /></g>
    </SvgIcon>,
    name: 'Stock',
    url: '/stock',
    subgrupos:
         [
           {
             name: 'Calidad',
             url: '/stock/calidad',
             subgrupos: [
               {
                 name: 'Importar archivo analisis',
                 url: '/stock/calidad/importararchivoanalisis'
               },
               {
                 name: 'Solicitud archivo analisis',
                 url: '/stock/calidad/solicitudanalisis'
               },
               {
                 name: 'Solicitiud archivo analisis embarque',
                 url: '/stock/calidad/solicitudanalisisembarque'
               },
               {
                 name: 'Mercaderia sin analisis',
                 url: '/stock/calidad/mercaderiasinanalisis'
               },
               {
                 name: 'Mercaderia embarcada',
                 url: '/stock/calidad/mercaderiaembarcada'
               },
               {
                 name: 'Control de grado',
                 url: '/stock/calidad/controldegrado'
               },
               {
                 name: 'Control de rebajas',
                 url: '/stock/calidad/controlderebajas'
               }
             ]
           },
           {
             name: 'Control Diario',
             url: '/stock/controlDiario',
             subgrupos: [
               {
                 name: 'Descarga diaria',
                 url: '/stock/controlDiario/descargadiaria'
               },
               //  {
               //    name: 'Descarga en extra',
               //    url: '/stock/controlDiario/descargaenextra'
               //  },
               {
                 name: 'Carga diaria',
                 url: '/stock/controlDiario/cargadiaria'
               },
               {
                 name: 'Compras de exportador a la Terminal',
                 url: '/stock/controlDiario/ventaaexportador'
               }
             ]
           },
           {
             name: 'Calculo de Stock',
             url: '/stock/calculoDeStock'
           },
           {
             name: 'Interdictos',
             url: '/stock/interdictos'
           },
           {
             name: 'Listados Facturacion',
             url: '/stock/listados',
             subgrupos: [
               {
                 name: 'Mercadería fumigada',
                 url: '/stock/listados/mfumigada'
               },
               {
                 name: 'Mercadería secada',
                 url: '/stock/listados/msecada'
               },
               {
                 name: 'Mercadería por grado',
                 url: '/stock/listados/mporgrado'
               },
               {
                 name: 'Mercadería con rebaja adicional',
                 url: '/stock/listados/mrebajaadicional'
               },
               {
                 name: 'Total almacenaje de mercadería',
                 url: '/stock/listados/almacenaje'
               },
               {
                 name: 'Total almacenaje especial',
                 url: '/stock/listados/almacenajeespecial'
               },
               {
                 name: 'Mercadería zarandeada',
                 url: '/stock/listados/mzarandeada'
               },
               {
                 name: 'Índices de merma de calidad',
                 url: '/stock/listados/indices'
               }
             ]
           },
           {
             name: 'Movimientos exportador',
             url: '/stock/exportador',
             subgrupos: [
               {
                 name: 'Movimientos exportador',
                 url: '/stock/exportador/movimientosexportador'
               },
               {
                 name: 'Transferencias entre exportadores',
                 url: '/stock/exportador/transferenciasexp'
               },
               {
                 name: 'Cambio de cereal',
                 url: '/stock/exportador/cambiocerealexportador'
               }
             ]
           },
           {
             name: 'Movimientos Terminal',
             url: '/stock/terminal',
             subgrupos: [
               {
                 name: 'Reconocimiento de stock',
                 url: '/stock/terminal/reconocimiento'
               },
               {
                 name: 'Ventas a exportador',
                 url: '/stock/terminal/ventasaexportador'
               }
             ]
           },
           {
             name: 'Control de existencias',
             url: '/stock/controlexistencias',
             subgrupos: [
               {
                 name: 'Existencia diaria',
                 url: '/stock/existenciadiaria'
               },
               {
                 name: 'Consulta por cosecha',
                 url: '/stock/consultaporcosecha'
               }
               //  {
               //    name: 'Ranking exportadores',
               //    url: '/stock/rankingexportadores'
               //  }
             ]
           },
           //  {
           //    name: 'Proyección',
           //    url: '/stock/controlexistencias',
           //    subgrupos: [
           //      {
           //        name: 'Estimación semanal',
           //        url: '/stock/estimacionsemanal'
           //      },
           //      {
           //        name: 'Proyección stock',
           //        url: '/stock/proyeccionstock'
           //      }
           //    ]
           //  },
           {
             name: 'Generar Archivos',
             url: '/stock/generarArchivos'
           }
         ]
  },

  // MOVIMIENTO-------------------------------------------------------------------------------------------------

  {
    icono: <SvgIcon>
      <rect fill='none' height='24' width='24' /><path d='M19,12h3L12,3L2,12h3v8h2v-2h10v2h2V12z M7.21,10h9.58L17,10.19V12H7v-1.81L7.21,10z M14.57,8H9.43L12,5.69L14.57,8z M7,16 v-2h10v2H7z' />
    </SvgIcon>,
    name: 'Movimiento',
    url: '/movimiento',
    subgrupos: [
      {
        name: 'Control de Silos',
        url: '/movimiento/abm'
      },
      {
        name: 'Silos 3D',
        url: '/movimiento/vista3d'
      },
      {
        name: 'Cuadro de Mando',
        url: '/movimiento/cuadroDeMando'
      },
      // {
      //   name: 'Reporte por Silos',
      //   url: '/movimiento/reportePorSilos'
      // },
      // {
      //   name: 'Distribución por Cereal',
      //   url: '/movimiento/distribucionPorCereal'
      // },
      // {
      //   name: 'Distribución por Condición',
      //   url: '/movimiento/distribucionPorCondicion'
      // },
      // {
      //   name: 'Espacio por Cereal',
      //   url: '/movimiento/espacioPorCereal'
      // },
      // {
      //   name: 'Reporte por Sector',
      //   url: '/movimiento/reportePorSector'
      // },
      // {
      //   name: 'Reporte por Cereal',
      //   url: '/movimiento/reportePorCereal'
      // },
      // {
      //   name: 'Reporte para Embarque',
      //   url: '/movimiento/reporteParaEmbarque'
      // },
      {
        name: 'Listados y Consultas',
        url: '/movimiento/listado',
        subgrupos: [
          {
            name: 'Consulta Movimientos de Mercadería',
            url: '/movimiento/listado/consultaMovimientosMercaderia'
          }
        ]
      }
    ]
  },

  // CONFIGURACION-------------------------------------------------------------------------------------------------
  {
    name: 'Configuracion',
    url: '/configuracion',
    subgrupos:
          [

          ]
  },

  // Vistas Sin Asignar-------------------------------------------------------------------------------------------------

  // EJEMPLO-------------------------------------------------------------------------------------------------

  /* {
    name: 'con 2 Subgrupos',
    url: '/cupos/modificacion',
    subgrupos: [
      {
        name: 'con 1 Subgrupos 1',
        url: '/cupos/modificacion',
        subgrupos: [
          {
            name: 'Sin Subgrupo 4',
            url: '/cupos/modificacion',
          },
        ]
      },
      {
        name: 'con 1 Subgrupos 2',
        url: '/cupos/modificacion',
        subgrupos: [
          {
            name: 'Sin Subgrupo 5',
            url: '/cupos/modificacion',
          },
        ]
      },
    ]
  }, */
  {
    icono: <PolicyIcon />,
    name: 'Vigilancia',
    url: '/vigilancia',
    subgrupos: [
      {
        name: 'Control Barreras de Calado',
        url: '/vigilancia/barrerascalado'
      }
    ]
  },
  {
    icono: <WhatsAppIcon />,
    name: 'Utilidades',
    url: '/utilidades',
    subgrupos: [
      {
        name: 'Mensajería',
        url: '/utilidades/mensajeria'
      }
    ]
  }
]

export const ITEMS_PREINGRESO = [
  // PREINGRESO CALADO ---------------------------------------------------------------------------------------------------
  { icono: <LocalShippingIcon />,
    name: 'Preingreso a calado',
    url: '/accesoPreingreso',
    subgrupos: [
      {
        name: 'Acceso a calles de preingreso',
        url: '/accesoPreingreso',
        subgrupos: [

        ]
      }
      //   {
      //   name: 'Preingreso a calado',
      //   url: '/accesoPreingreso',
      //   subgrupos: [
      //     {
      //       name: 'Preingreso Calado 1-2',
      //       url: '/preingresoCalado/1-2'
      //     },
      //     {
      //       name: 'Preingreso Calado 3-4',
      //       url: '/preingresoCalado/3-4'
      //     }
      //   ]
      // }

    ]
  }

]
